import { useState } from "react";
import TodayReport from "../components/TodayReport/TodayReport";
import styles from "./Dashboard.module.css";
import { Header } from "./Header";
import { OccupancyChart } from "./OccupancyChart";
import { RoomOccupancyStatus } from "./RoomOccupancyStatus";
import { RoomOverview } from "./RoomOverview";
import { RoomStatus } from "./RoomStatus";

export const MainContent = ({ data, loading }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <main className={styles.mainContent}>
      <Header showCreateBookingBtn={false} data={data} loading={loading} />
      {/* <Statistics hotelId={hotelId} /> */}
      <TodayReport data={data} loading={loading} />
      <RoomOverview data={data} loading={loading} />
      <div className={styles.gridContainer}>
        <div className={styles.statusSection}>
          <RoomStatus data={data} loading={loading} />
          <RoomOccupancyStatus data={data} loading={loading} />
        </div>
        <div className={styles.feedSection}>
          <OccupancyChart data={data} loading={loading} />
          {/* <FeedbackSection hotelId={hotelId} /> */}
        </div>
      </div>
      {/* <AvailModel
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        hotelId={hotelId}
      /> */}
    </main>
  );
};
